// Generated on 2026-07-14T20:30:32.149Z
// This file contains preloaded categorias destacadas data from the API
// Do not edit manually - use 'npm run generate:productos-destacados-data' to regenerate

export const preloadedProductosDestacados: any = [
  {
    "id": 856,
    "name": "Fricciones",
    "slug": "fricciones",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-300128-0565/thumb/01-300128-0565_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 835,
    "name": "Amortiguadores",
    "slug": "amortiguadores",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-200140-0021/thumb/01-200140-0021_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 839,
    "name": "Tijeras o Brazos de Control",
    "slug": "tijeras-o-brazos-de-control",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/02-201034-0724/thumb/02-201034-0724_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 764,
    "name": "Link de Estabilizadoras",
    "slug": "link-de-estabilizadoras",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/02-201022-0030/thumb/02-201022-0030_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 796,
    "name": "Muñequines",
    "slug": "munequines",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/02-201008-0816A/thumb/02-201008-0816A_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 1346,
    "name": "Soporte de Motor",
    "slug": "soporte-de-motor",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-050656-0730/thumb/01-050656-0730_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 890,
    "name": "Hules de Barra Estabilizadora",
    "slug": "hules-de-barra-estabilizadora",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-200223-0414F/thumb/01-200223-0414F_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 1419,
    "name": "Empaque de Tapadera de Valvulas",
    "slug": "empaque-de-tapadera-de-valvulas",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-050517-0721/thumb/01-050517-0721_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 1669,
    "name": "Bujias de Ignicion",
    "slug": "bujias-de-ignicion",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-409984-0087/thumb/01-409984-0087_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 869,
    "name": "Balineras de Rueda",
    "slug": "balineras-de-rueda",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-150806-0050/thumb/01-150806-0050_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 704,
    "name": "Bujes de Tijeras o Brazos de Control",
    "slug": "bujes-de-tijeras-o-brazos-de-control",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/02-201033-0205/thumb/02-201033-0205_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 743,
    "name": "Esfericas o Rotulas",
    "slug": "esfericas-o-rotulas",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-200102-0680/thumb/01-200102-0680_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 858,
    "name": "Bufa Completa",
    "slug": "bufa-completa",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-150206-0415/thumb/01-150206-0415_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 709,
    "name": "Discos de Frenos",
    "slug": "discos-de-frenos",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-300118-0408/thumb/01-300118-0408_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 802,
    "name": "Peine",
    "slug": "peine",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-200107-0404/thumb/01-200107-0404_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 847,
    "name": "Tijeras o Brazos Laterales",
    "slug": "tijeras-o-brazos-laterales",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-200534-0836/thumb/01-200534-0836_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 1673,
    "name": "Bobina de Encendido",
    "slug": "bobina-de-encendido",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-400127-0002/thumb/01-400127-0002_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 708,
    "name": "Fricciones",
    "slug": "fricciones",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-300129-0427/thumb/01-300129-0427_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 859,
    "name": "Maza o Bufa de Rueda",
    "slug": "maza-o-bufa-de-rueda",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-150805-0009/thumb/01-150805-0009_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 740,
    "name": "Bomba del Hidraulico o de Power Steering",
    "slug": "bomba-del-hidraulico-o-de-power-steering",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-200113-0432/thumb/01-200113-0432_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 746,
    "name": "Bomba Madre de Frenos",
    "slug": "bomba-madre-de-frenos",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-300102-0418/thumb/01-300102-0418_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 699,
    "name": "Sensor de Velocidad de Rueda de Abs",
    "slug": "sensor-de-velocidad-de-rueda-de-abs",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-500180-0423/thumb/01-500180-0423_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 1265,
    "name": "Juego de Tiempo",
    "slug": "juego-de-tiempo",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/02-051042-0401/thumb/02-051042-0401_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  },
  {
    "id": 705,
    "name": "Switch de Direccion Asistida",
    "slug": "switch-de-direccion-asistida",
    "url_imagen": "https://allasfileserver.s3.amazonaws.com/fotos_pagina_web/products/01-400168-0403/thumb/01-400168-0403_0_13_1.webp",
    "mostrar_como_categoria_principal": false
  }
];

export default preloadedProductosDestacados;
